/* PoliceRadio ZIP checker — dynamic per-county SEO section (Aug 2026)
 * Loads AFTER county-picker.js and zip-county-data.js.
 *
 * Two jobs:
 *  1. Wrap window.PR_ZIP.renderCounty so that every zip/county check also
 *     renders a "What to expect in [County], [State]" H2 block (real status
 *     + police/fire/EMS breakdown + trunked note) into #zcCountyDetail.
 *  2. Handle deep links #st-CA from the 50-state coverage section: preselect
 *     the state in the browse dropdown and scroll to it.
 */
(function () {
  if (!window.PR_ZIP || !window.PR_COUNTY_STATUS) return;

  /* ---- county-name suffix logic (mirrors county-picker.js split) ---- */
  var SUFFIX = { "~": " Parish", "^": " Borough", "*": " Census Area", "+": " City and Borough", "%": " Municipality", "!": " city", "?": "" };
  function splitEntry(entry) {
    var c = entry.charAt(0);
    return SUFFIX[c] !== void 0 ? { n: entry.slice(1), s: SUFFIX[c] } : { n: entry, s: " County" };
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  var STATUS_LABEL = {
    open: { short: "Open / analog", detail: "police dispatch is conventional analog — a standard scanner hears it" },
    digital: { short: "Digital (P25)", detail: "police run on a digital P25 system — a P25-capable scanner is required" },
    encrypted: { short: "Encrypted", detail: "police encryption blocks every consumer scanner at any price" },
    mixed: { short: "Mixed", detail: "coverage is a mix of analog and digital — police varies by agency" }
  };

  function serviceRow(status, label, yesText, noText, mixText) {
    if (!status) return "";
    var pill, note;
    if (status === "open") { pill = "YES"; note = yesText; }
    else if (status === "encrypted") { pill = "NO"; note = noText; }
    else if (status === "digital") { pill = "NO"; note = noText; }
    else { pill = "CHECK"; note = mixText; }
    return '<div class="zc-row"><span class="zc-pill ' + (pill === "YES" ? "zc-y" : pill === "NO" ? "zc-n" : "zc-m") + '">' + pill + '</span><div><div class="zc-lbl">' + label + '</div><div class="zc-note">' + note + '</div></div></div>';
  }

  function renderDetail(out, ab, entry) {
    var detail = document.getElementById("zcCountyDetail");
    if (!detail) return;
    var p = splitEntry(entry);
    var key = (ab + ":" + p.n).toLowerCase();
    var state = window.PR_ZIP.SN && window.PR_ZIP.SN[ab] || ab;
    /* Curated counties (Fresno/Tulare/Merced/Gallatin) have a hand-verified
       card with real frequency data that may differ from the RR crawl — the
       curated card is authoritative, so do NOT render a conflicting detail. */
    var cvKey = ab + ":" + p.n;
    var P = window.PR_COUNTIES;
    if (P && P.CV && P.CV[cvKey] && window.PR_ZIP.C && window.PR_ZIP.C[P.CV[cvKey]]) {
      detail.innerHTML = ""; detail.hidden = true; return;
    }
    var cs = window.PR_COUNTY_STATUS[key];
    if (!cs) { detail.innerHTML = ""; detail.hidden = true; return; }

    var status = cs[0];
    var policeOk = cs[1];
    var fire = cs[2];
    var ems = cs[3];
    var trunked = cs[4] || 0;

    var sl = STATUS_LABEL[status] || STATUS_LABEL.mixed;
    var full = p.n + p.s;

    var policeNote = policeOk === true
      ? "Law enforcement here is largely conventional analog — a hand-programmed scanner hears it."
      : policeOk === false
        ? "Law enforcement here is " + (status === "encrypted" ? "encrypted" : "digital / trunked") + " — an analog scanner cannot hear it."
        : "Police varies by agency here — worth confirming for your exact town before you buy.";

    var policeRow = '<div class="zc-row"><span class="zc-pill ' + (policeOk === true ? "zc-y" : policeOk === false ? "zc-n" : "zc-m") + '">' + (policeOk === true ? "YES" : policeOk === false ? "NO" : "CHECK") + '</span><div><div class="zc-lbl">Police &amp; law enforcement</div><div class="zc-note">' + policeNote + '</div></div></div>';
    var fireRow = serviceRow(fire, "Fire &amp; rescue", "Fire dispatch stays open — mutual aid depends on it.", "Fire here is digital/encrypted — check your exact town.", "Fire varies by agency here.");
    var emsRow = serviceRow(ems, "EMS &amp; ambulance", "EMS dispatch is receivable.", "EMS here is digital/encrypted.", "EMS varies by agency here.");
    var trunkRow = trunked > 0
      ? '<div class="zc-row"><span class="zc-pill zc-m">' + (trunked >= 3 ? "MANY" : "SOME") + '</span><div><div class="zc-lbl">Trunked radio systems</div><div class="zc-note">' + trunked + (trunked === 1 ? " trunked system" : " trunked systems") + ' on record here — trunked digital networks need a trunk-tracking scanner, not just an analog one.</div></div></div>'
      : "";

    detail.hidden = false;
    detail.innerHTML =
      '<div class="zc-sec"><span class="zc-sec-num">i</span><h2>What to expect in ' + esc(full) + ', ' + esc(state) + '</h2></div>' +
      '<div class="zc-card zc-detail-card">' +
        '<span class="zc-tag" style="background:#e1f5ee;color:#0f6e56">' + esc(sl.short) + '</span>' +
        '<p class="zc-detail-blurb">' + esc(sl.detail) + '. Fire, EMS, NOAA weather and aviation remain receivable almost everywhere.</p>' +
        policeRow + fireRow + emsRow + trunkRow +
        '<p class="zc-foot"><a href="/collections/police-scanners">Shop scanners for ' + esc(full) + ' \u2192</a> &nbsp; Want your exact town double-checked first? <a href="/pages/contact">Send us your zip</a>.</p>' +
      '</div>';

    if (detail.scrollIntoView && detail._first) {
      detail._first = false;
      // only scroll on the very first automated render if a hash target landed here
      if (location.hash && location.hash.indexOf("#st-") === 0) {
        setTimeout(function () { detail.scrollIntoView({ behavior: "smooth", block: "start" }); }, 100);
      }
    }
    detail._first = false;
  }

  /* ---- 1. wrap renderCounty ---- */
  var orig = window.PR_ZIP.renderCounty;
  if (typeof orig === "function") {
    window.PR_ZIP.renderCounty = function (out, ab, entry) {
      orig.call(this, out, ab, entry);
      renderDetail(out, ab, entry);
    };
  }

  /* ---- 2. deep links from the 50-state section (#st-CA) ---- */
  function applyStateHash() {
    var m = (location.hash || "").match(/^#st-([A-Z]{2})$/i);
    if (!m) return;
    var ab = m[1].toUpperCase();
    var root = document.querySelector("[data-zip-checker]");
    if (!root) return;
    var st = root.querySelector("[data-zc-state]");
    var ct = root.querySelector("[data-zc-county]");
    var out = root.querySelector("[data-zc-out]");
    if (!st || !ct || !out) return;
    if (st.value === ab) return;
    st.value = ab;
    if (st.onchange) st.onchange();
    else {
      var ev = document.createEvent("HTMLEvents");
      ev.initEvent("change", true, true);
      st.dispatchEvent(ev);
    }
    var browse = document.getElementById("zcBrowse");
    if (browse) setTimeout(function () { browse.scrollIntoView({ behavior: "smooth", block: "start" }); }, 120);
  }
  window.addEventListener("hashchange", applyStateHash);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", applyStateHash);
  else applyStateHash();
})();
